export const getGroupSizeColor = (guests: number) => {
  if (guests < 3) {
    return "var(--color-primary)";
  } else if (guests < 5) {
    return "var(--color-primary-1)";
  } else if (guests < 7) {
    return "var(--color-primary-2)";
  } else if (guests < 9) {
    return "var(--color-primary-3)";
  } else {
    return "var(--color-primary-4)";
  }
};

